export default [
    {
        show(row, extra) {
            return true
        },
        tag: 'my-btn',
        type: 'detail',
        text: '核实标书款',
        click(row, extra) {
            this.$get(`${this.getGetters('mngUrl')}/manage/finance/auditbsk/canseebs.json`, {
                bdcode: row.bdcode
            }, (data, res) => {
                this.goto({
                    path:"./bsk/list",
                    query:{
                        bdcode:row.bdcode
                    }
                });
            });
        }
    }
]
